
// DO NOT EDIT THIS FILE - IT IS GENERATED BY node run captureSecrets

// This should be fetched from https://accounts.google.com/.well-known/openid-configuration
// but it's probably not going to change, ever.
const OAUTH_GOOGLE_AUTHORIZATION_BASE_URL =
  "https://accounts.google.com/o/oauth2/auth";

const OAUTH_GOOGLE_ACCESS_TOKEN_ENDPOINT = 
  "https://www.googleapis.com/oauth2/v4/token";

const OAUTH_GOOGLE_WEB_CLIENT_ID = "1095415901925-m6fdpn2hgp6hltov4foqd4j7657t3884.apps.googleusercontent.com";
const OAUTH_GOOGLE_WEB_REDIRECT_URL = "https://onco-net.kumc.edu";

const OAUTH_GOOGLE_ANDROID_CLIENT_ID = "Test2";
const OAUTH_GOOGLE_ANDROID_REDIRECT_URI = "edu.kumc.onconet:/";

const OAUTH_GOOGLE_IOS_CLIENT_ID = "Test4";
const OAUTH_GOOGLE_IOS_URL_SCHEME = "Test6";
const OAUTH_GOOGLE_IOS_REDIRECT_URI = "edu.kumc.onconet:/";

const API_URLS = [ "https://onco-net.kumc.edu/api", "https://onco-net.kumc.edu/api", "https://onco-net.kumc.edu/api" ]

let API_URL = "https://onco-net.kumc.edu/api";

function setApiUrl(url: string) {
  API_URL = url;
}

export {
  API_URL,
  API_URLS,
  OAUTH_GOOGLE_ACCESS_TOKEN_ENDPOINT,
  OAUTH_GOOGLE_ANDROID_CLIENT_ID,
  OAUTH_GOOGLE_ANDROID_REDIRECT_URI,
  OAUTH_GOOGLE_AUTHORIZATION_BASE_URL,
  OAUTH_GOOGLE_IOS_CLIENT_ID,
  OAUTH_GOOGLE_IOS_REDIRECT_URI,
  OAUTH_GOOGLE_IOS_URL_SCHEME,
  OAUTH_GOOGLE_WEB_CLIENT_ID,
  OAUTH_GOOGLE_WEB_REDIRECT_URL,
  setApiUrl
};
